import { Component, OnInit, Input } from '@angular/core';
import { LdsUserService } from '../../services/lds-user.service';
import { IconsService } from '../../services/icons.service';
import { Router } from '@angular/router';

@Component({
    selector: 'lds-featureset-card-all-devices',
    templateUrl: './featureset-card-all-devices.component.html',
    styleUrls: ['./featureset-card-all-devices.component.css'],
    standalone: false
})
export class FeaturesetCardAllDevicesComponent implements OnInit {

  @Input() featureSetId: string;
  featureSet: any;
  margin: string;
  iconProductCode: string

  constructor(private user: LdsUserService, public icons: IconsService, private router: Router) { }

  ngOnInit() {
    const truncateFunc = function (text, n) {
      return (text.length > n) ? text.substr(0, n - 1) + '...' : text;
    };
    const allDevices = this.user.allDevices;

    this.featureSet = allDevices.find(device => {
      if (device.groupId === this.featureSetId) {
        return device;
      }
    });

    const virtualProductCode = this.user.findVirtualProductCode(this.featureSet);

    if (this.featureSet) {
      this.featureSet.displayName = truncateFunc(this.featureSet.name, 10);
      if(virtualProductCode && virtualProductCode !== this.featureSet.productCode){
        this.iconProductCode = virtualProductCode;
      }else{
        if(this.featureSet.productCode){
        this.iconProductCode = this.featureSet.productCode;
        }
      }
    }


  }

  clicked() {

      const hasEnergy = () => {
        return this.featureSet.features.find((featureId) => this.user.features[featureId].attributes.type === 'energy')
      }

      if(this.featureSet.productCode === "L70" || this.featureSet.productCode === "L70MK2"){
        this.router.navigateByUrl('data-studio/detail/motion/' + this.featureSet.groupId);
        return;
      }
      const urlSegment = hasEnergy() ? 'energy' : this.featureSet.type;
      this.router.navigateByUrl('data-studio/detail/' + urlSegment + '/' + this.featureSet.groupId);
    }
}
